/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import API from 'api';
import Box from '@material-ui/core/Box';
import Ad from 'models/business/Ad';
import PhonePreview from 'components/pages/ResourceSetting/Widgets/PhonePreview';
import PresentationFormatField from 'components/pages/ResourceSetting/Widgets/PresentationFormatField';
import HideableContainer from 'components/Common/HideableContainer';
import useModelConvenience from 'components/hooks/useModelConvenience';
import MainForm from './MainForm';
import DisabledForm from './DisabledForm';
import Styles from './index.module.css';

export default function CPASDashboard() {
  const [ad, setAd] = useState(new Ad());
  const [firstEdit, setFirstEdit] = useState(false);
  const [media, setMedia] = useState({
    prepopulated: null,
    local: null,
  });
  const location = useLocation();
  const { fullyPopulateMarket } = useModelConvenience();

  const handleChangePresentationFormat = (format) => {
    const newAd = ad.clone();
    newAd.platform = format;
    setAd(newAd);
  };

  const fetchAssets = async (id) => {
    const result = await API.ad.getAdAssets(id);
    if (!result.error) {
      return result;
    }
    return [];
  };

  useEffect(() => {
    const newAd = new Ad(location.state?.ad);
    if (newAd.id) {
      // setAd(newAd);
      fetchAssets(newAd.id).then((assets) => {
        newAd.injectAssets(assets);
        fullyPopulateMarket(newAd).then((a) => a && setAd(a));
      });
    }
    setFirstEdit(!!location.state?.firstEdit);
  }, [location]);

  return (
    <div>
      <Box marginBottom={5}>
        <PresentationFormatField
          presentationFormat={ad.platform}
          onChangePresentationFormat={handleChangePresentationFormat}
        />
      </Box>
      <HideableContainer hidden={!ad.platform} className={Styles.phonePreviewContainer}>
        <PhonePreview media={media} ad={ad} className={Styles.phonePreview} />
      </HideableContainer>
      {ad.platform ? (
        <MainForm
          ad={ad}
          onChangeAd={setAd}
          firstEdit={firstEdit}
          onChangeMedia={setMedia}
        />
      ) : (
        <DisabledForm onChangePresentationFormat={handleChangePresentationFormat} />
      )}
    </div>
  );
}
